var reviewIncident = (function () {
    
    function loadPage(reviewData, incidentId, consumer) {
        DOM.clearActionCenter();
        let newIncidentCard;
        if (consumer) {          
             newIncidentCard = incidentCard.build(reviewData, consumer);
        }
        else {
             newIncidentCard = incidentCard.build(reviewData);
        }
       
        DOM.ACTIONCENTER.appendChild(newIncidentCard);

        incidentPermissions.permissions(reviewData.itReviewData[0].originallyEnteredByUserId);

        DOM.autosizeTextarea();
    }

    function init(incidentId, selectedConsumer) {
        incidentTrackingAjax.getIncidentEditReviewDataAllObjects(incidentId, results => {
            incident.setUpdateIncidentId(incidentId);
            loadPage(results, incidentId, selectedConsumer);
        });
    }

    return {
        init,
    };
})();
